import { ReactNode } from "react";

export const SensitiveDataSection = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => (
  <div className="t-flex t-flex-col t-gap-4 t-rounded-lg t-border t-border-solid t-border-neutral-10 t-bg-surface t-p-4">
    <span className="t-text-subtext t-text-text-100">{title}</span>
    <span className="t-h-px t-w-full t-bg-neutral-10" />
    {children}
  </div>
);
